// FIXME: Need to be refactored
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { REACT_APP_PATH_WEB_SOCKET } from '../../config/settings/environment'
import { w3cwebsocket as W3CWebSocket } from 'websocket'
import routes from '../../config/settings/routes'
import moment from 'moment'
import 'moment/locale/es'
import { getLastUpdateAWS } from '../../services/fuelLevelService'
import { useHistory } from 'react-router'
import {
  onSetMissingTimeSuccess,
  onWsDataTrucksThunk,
  onGetOrpakLatestThunk,
  onGetFuelSourceComparisonThunk,
  onGetServerStatusThunk
} from './Countdown.actions'
import { Typography } from '@material-ui/core'
import useStyles from '../../styles/levelsStyle'
import TruckModel from '../../store/models/truck'
import { onSaludTimelineSuccess } from '../FuelLevel/FuelLevel.actions'
import { onLogOutThunk } from '../Authentication/Authentication.actions'

moment.locale('es')
let last = moment()

/**
 * The Countdown's container.
 */
const Countdown = () => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const history = useHistory()
  const { missingTime } = useSelector(state => state.countdown)
  let client = null

  const websocketComunication = () => {
    client = new W3CWebSocket(REACT_APP_PATH_WEB_SOCKET)
    client.onopen = e => {
      console.log('Conectado al websocket')
    }
    client.onmessage = message => {
      const { data } = message
      const dataParse = JSON.parse(data)
      switch (dataParse.type) {
        case 'latest_orpak': {
          const orpak = dataParse.value
          const tankLevelsMean = dataParse.nivel_estanque_mean
          const weeklyTank = dataParse.nivel_estanque_week_mean
          const dayTurn = dataParse.turno_dia
          const nightTurn = dataParse.turno_noche
          dispatch(onGetOrpakLatestThunk(orpak, tankLevelsMean, weeklyTank, dayTurn, nightTurn))
          break
        }
        case 'fuel_source_comparison': {
          dispatch(onGetFuelSourceComparisonThunk(dataParse.value))
          break
        }
        case 'salud_timeline': {
          dispatch(onSaludTimelineSuccess({ saludTimeline: dataParse.value }))
          break
        }
        default: {
          // The trucks payload is expected to be an array. API Gateway errors,
          // acks or unknown message types arrive as objects and must be ignored.
          if (!Array.isArray(dataParse)) {
            console.warn('Countdown websocket: unexpected payload, ignoring', dataParse)
            break
          }
          const trucks = dataParse.map(truck => new TruckModel().fromV1(truck))
          dispatch(onWsDataTrucksThunk(trucks))
          // the "full message" arriving is also the signal to refresh the service health badge
          dispatch(onGetServerStatusThunk())
        }
      }
      reloadView()
    }

    client.onclose = e => {
      console.error('comunicación cerrada: ', e.code, e.reason)
      if (e.code === 1001 || e.code === 1006) {
        setTimeout(websocketComunication, 10000)
      }
    }
  }

  useEffect(() => {
    websocketComunication()
    const myInterval = setInterval(() => {
      const now = moment()
      if (now.diff(last, 'minutes') > 10) {
        reloadView()
      }
      dispatch(onSetMissingTimeSuccess({ missingTime: last.fromNow() }))
    }, 60000)

    return () => {
      clearTimeout(myInterval)
      client.close()
    }
  }, [])

  const fetchData = async () => {
    let timeUpdate
    try {
      timeUpdate = await getLastUpdateAWS()
    } catch (error) {
      console.log('getLastUpdateAWS failed:', error)
      // Only force logout on a real auth failure, not a missing/404 endpoint.
      const status = error?.response?.status
      if (status === 401 || status === 403) {
        return dispatch(onLogOutThunk({ onCallback: () => history.push(routes.login) }))
      }
      return null
    }

    // API may not exist yet (or returned nothing) — bail gracefully instead of crashing.
    if (!timeUpdate || !timeUpdate.last_update_date || !timeUpdate.last_update_time) {
      return null
    }

    const dateAux = timeUpdate.last_update_date.split('/')
    const timeAux = timeUpdate.last_update_time.split(':')
    const last = moment().set({
      year: dateAux[2],
      month: dateAux[1] - 1,
      date: dateAux[0],
      hour: timeAux[0],
      minute: timeAux[1],
      second: timeAux[2]
    })
    return last.fromNow()
  }

  const reloadView = async () => {
    const missing = await fetchData()
    dispatch(onSetMissingTimeSuccess({ missingTime: missing }))
    last = moment()
  }

  return (
    <Typography className={classes.label} style={{ textAlign: 'center' }}>
      última actualización: {missingTime}.
    </Typography>
  )
}

export default Countdown
